import {AddItemResponseStatus_Success_Section_BasketUrgency_SimpleHint} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import {Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {BasketUrgencyHintWrapper} from './BasketUrgencyHintWrapper';

export const BasketUrgencySimpleHint: React.FC<{
  simpleHint: AddItemResponseStatus_Success_Section_BasketUrgency_SimpleHint;
}> = ({simpleHint}) => {
  return (
    <BasketUrgencyHintWrapper
      backgroundColor={simpleHint.backgroundColor}
      infoBox={simpleHint.infoBox}
      foregroundColor={simpleHint.foregroundColor}
    >
      <StyledText
        data-testid="basketUrgencyHintText"
        size="px12"
        $foregroundColor={simpleHint.foregroundColor.hex}
        dangerouslySetInnerHTML={{__html: simpleHint.text.text}}
      />
    </BasketUrgencyHintWrapper>
  );
};

const StyledText = styled(Text)<{
  $foregroundColor: string;
}>`
  line-height: 1.5;
  text-align: center;
  color: ${props => props.$foregroundColor};
`;
